import React from 'react'

export default (props) => {
  return (
    <>
      <img
        className={props.className}
        srcset={props.srcSet}
        sizes={props.sizes}
        src={props.src}
        alt={props.alt} 
      />
    </>
  )
}